import { render } from "./GeraProposta.vue?vue&type=template&id=2445466e"
import script from "./GeraProposta.vue?vue&type=script&lang=js"
export * from "./GeraProposta.vue?vue&type=script&lang=js"

import "./GeraProposta.vue?vue&type=style&index=0&id=2445466e&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__